import { ChantContext } from '../../gregorio-chant/ChantContext';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { VisualizerHelper } from '../visualizers/VisualizerHelper';
import { DistanceConverter } from '../distances/DistanceConverter';
import { Length, RubberLength } from '../distances';

export class Space extends ChantLayoutElement {
  public constructor(
    context: ChantContext,
    width: number,
  ) {
    super(context);
    this.bounds.setWidth(width);
  }

  public static createFromWidth(context: ChantContext, width: Length | RubberLength): Space {
    const dc = new DistanceConverter(context);
    return new Space(context, dc.lengthToPx(width));
  }

  public static createFromElementEnd(context: ChantContext, enumValue: number, unbreakable: boolean): Space {
    let width = 0;
    const dc = new DistanceConverter(context);

    switch (enumValue) {
      case 0:
        width = dc.lengthToPx(context.interelementspace);
        break;
      case 1:
        width = dc.lengthToPx(context.largerspace);
        break;
      case 2:
        width = dc.lengthToPx(context.glyphspace);
        break;
      case 3:
        width = dc.lengthToPx(context.zerowidthspace);
        break;
      case 4:
        // custom space is not supported
        break;
    }

    return new Space(context, width);
  }

  public static createFromGlyphEnd(context: ChantContext, enumValue: number): Space {
    let width = 0;
    const dc = new DistanceConverter(context);

    switch (enumValue) {
      case 0:
        width = dc.lengthToPx(context.interglyphspace);
        break;
      case 1:
        width = dc.lengthToPx(context.zerowidthspace);
        break;
      case 2:
        // never goes here
        width = dc.lengthToPx(context.alterationspace);
        break;
      case 3:
        width = dc.lengthToPx(context.punctuminclinatumshift);
        break;
      case 4:
        width = dc.lengthToPx(context.bitrivirspace);
        break;
      case 5:
        width = dc.lengthToPx(context.bitristrospace);
        break;
      case 6:
        width = dc.lengthToPx(context.spaceaftersigns);
        break;
      case 7:
        width = dc.lengthToPx(context.punctuminclinatumanddebilisshift);
        break;
      case 8:
        width = dc.lengthToPx(context.punctuminclinatumdebilisshift);
        break;
      case 9:
        width = dc.lengthToPx(context.beforepunctainclinatashift);
        break;
      case 10:
        width = dc.lengthToPx(context.punctuminclinatumbigshift);
        break;
      case 11:
        width = dc.lengthToPx(context.punctuminclinatummaxshift);
        break;
      case 12:
        width = dc.lengthToPx(context.ascendingpunctuminclinatumshift);
        break;
      case 13:
        width = dc.lengthToPx(context.ascendingpunctuminclinatumanddebilisshift);
        break;
      case 14:
        width = dc.lengthToPx(context.ascendingpunctuminclinatumbigshift);
        break;
      case 15:
        width = dc.lengthToPx(context.ascendingpunctuminclinatummaxshift);
        break;
      case 16:
        width = dc.lengthToPx(context.descendinginclinatumtonobarshift);
        break;
      case 17:
        width = dc.lengthToPx(context.descendinginclinatumtonobarbigshift);
        break;
      case 18:
        width = dc.lengthToPx(context.descendinginclinatumtonobarmaxshift);
        break;
      case 19:
        width = dc.lengthToPx(context.ascendinginclinatumtonobarshift);
        break;
      case 20:
        width = dc.lengthToPx(context.ascendinginclinatumtonobarbigshift);
        break;
      case 21:
        width = dc.lengthToPx(context.ascendinginclinatumtonobarmaxshift);
        break;
      case 22:
        width = dc.lengthToPx(context.halfspace);
        break;
      case 23:
        width = dc.lengthToPx(context.punctuminclinatumunisonshift);
        break;
      case 24:
        width = dc.lengthToPx(context.descendingpunctuminclinatumascendingshift);
        break;
      case 25:
        width = dc.lengthToPx(context.ascendingpunctuminclinatumdescendingshift);
        break;
      case 26:
        width = dc.lengthToPx(context.uprightpunctuminclinatumshift);
        break;

      default:
        throw new Error('wrong space');
    }

    return new Space(context, width);
  }

  public performLayout(prevElements: ChantLayoutElement[]): void {
    const prevElement = VisualizerHelper.findLastGlyphOrSpaceOrBarOrSign(prevElements);
    if (prevElement) {
      this.bounds.setX(prevElement.bounds.right);
    } else {
      this.bounds.setX(0);
    }
  }

  public createSvgFragments(): SVGElement[] {
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    if (this.bounds.width > 0) {
      rect.setAttribute('x', String(this.bounds.x));
      rect.setAttribute('width', String(this.bounds.width));    
    } else {
      rect.setAttribute('x', String(this.bounds.x + this.bounds.width));
      rect.setAttribute('width', String(0));
    }
    rect.setAttribute('y', String(this.bounds.y));
    rect.setAttribute('height', String(this.bounds.height));
    rect.setAttribute('fill', 'none');
    return [
      rect
    ];
  }
}
